module.exports = __webpack_public_path__ + "static/media/FOSTER_ELIGIBLE.83ec64a1.svg";